import registerResponseSupportController from './ResponseSupportController';

export default function registerResponseSupport(angular) {
    registerResponseSupportController(angular.module('assessmentFrontendControllers'));
}

